import { useMemo } from 'react';

import { usePermission } from '../../providers';
import { validatePermissions } from '../../utils';

function useHasPermission(permission: string | string[], operator: 'AND' | 'OR' = 'AND') {
  const context = usePermission();

  return useMemo(
    () => validatePermissions(permission, context.permissions, operator),
    [context.permissions, permission, operator],
  );
}

export { useHasPermission };
